// extracted by mini-css-extract-plugin
export default {"bookingTimeArea":"booking-list-time_bookingTimeArea__ni4Ym"};